import {
  canShowSketchPropertySection,
  handleSketchEntityPropertyConfirm,
  registerPropertyManagerSection,
} from '@/core';
import { SketchRectangleCommand } from '@puppycad/cad-core';
import RectanglePropertySection from '@/components/editor/property-manager/rectangle/RectanglePropertySection.vue';


registerPropertyManagerSection({
  id: SketchRectangleCommand.Corner,
  title: '矩形',
  order: 10,
  component: RectanglePropertySection,
  actions: {
    confirm: true,
  },
  onConfirm: handleSketchEntityPropertyConfirm,
  isApplicable: (context) => canShowSketchPropertySection(context, context.rectanglePropertyVisible === true),
});
